"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=room-transition-rule.dto.js.map